import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=dcb29a3c&"
import script from "./copy.vue?vue&type=script&lang=js&"
export * from "./copy.vue?vue&type=script&lang=js&"
import style0 from "./copy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports